export const apiUrl =
  "https://api.usafoam.co";
export const s3Url = "https://modx-dev.s3.eu-north-1.amazonaws.com";

export const imageUrl = (url) => {
  const result = url?.indexOf("http");
  const imageRenderUrl = result == -1 ? `${s3Url}/${url}` : url;
  return imageRenderUrl;
};
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
